<mat-list class="notification-list">
  <div class="close-btn-wrapper">
    <span class="title">
      <mat-icon>notifications</mat-icon>
      {{ 'notifications' | translate }}
    </span>

    <button mat-icon-button aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-list-item *ngFor="let n of notifications" (click)="onSelect(n)" [class.unread]="!n.read" class="notification-item">
    <mat-icon matListItemIcon>{{ n.icon || 'notifications' }}</mat-icon>
    <div matListItemTitle class="title">{{ n.title }}</div>
    <div matListItemLine class="version-date">
      <span class="date">{{ n.activeUntil | date: 'dd MMMM yyyy' }}</span>
      <span class="dot" *ngIf="n.notificationType">●</span>
      <span class="version">{{ n.notificationType }}</span>
    </div>
  </mat-list-item>
</mat-list>
